<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item :to="{ path: '/pressservice' }">{{$t('app.bosh_link5')}}
                                    </el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('app.bosh_link')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-1 mb-3">
                <div class="container">
                    <el-row :gutter="10">
                        <el-col :sm="24" :md="24" :lg="19" class="mb-3">
                            <card shadow class="card_radius_no" no-body style="z-index: 10;">
                                <div class="px-4" id="printMe">
                                    <div class="text-center mt-5">
                                        <div class="h6 mt-4">
                                            <i class="ni business_briefcase-24 mr-2"></i>
                                            <span class="news_title">
                                        <strong v-if="$i18n.locale === 'uz-UZ'">{{news.titleUzLat}}</strong>
                                        <strong v-if="$i18n.locale === 'uz-CYR'">{{news.titleUz}}</strong>
                                        <strong v-if="$i18n.locale === 'ru-RU'">{{news.tilteRu}}</strong>
                                        <strong v-if="$i18n.locale === 'en-US'">{{news.titleEn}}</strong>
                                    </span>
                                        </div>
                                    </div>
                                    <div class="mt-5 py-5 border-top text-center">
                                        <div class="row justify-content-center">
                                            <div class="col-lg-11">
                                                <p style="text-align: justify;" class="new_responsive"
                                                   v-html="newsContent"></p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                              <div class="print_div">
<!--                                <div class="share_link">-->
<!--                                </div>-->

                                <twitter :url="pageUrl" trigger="click" scale="2" class="share_link_div"></twitter>
<!--                                <facebook :url="pageUrl" trigger="click" scale="2" class="share_link_div"></facebook>-->
                                <telegram :url="pageUrl" trigger="click" scale="2" class="share_link_div" :title="pageTitle"></telegram>

<!--                                <el-dropdown class="share_link" trigger="click">-->
<!--                                        <span class="el-dropdown-link">{{$t('app.share')}}<i-->
<!--                                            class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--                                        </span>-->
<!--                                  <el-dropdown-menu slot="dropdown">-->
<!--                                    <el-dropdown-item>-->
<!--                                      <twitter :url="pageUrl" scale="2"></twitter>-->
<!--                                    </el-dropdown-item>-->
<!--                                    <el-dropdown-item>-->
<!--                                      <facebook :url="pageUrl" scale="2"></facebook>-->
<!--                                    </el-dropdown-item>-->
<!--                                    <el-dropdown-item>-->
<!--                                      <telegram :url="pageUrl" scale="2" :title="pageTitle"></telegram>-->
<!--                                    </el-dropdown-item>-->
<!--                                  </el-dropdown-menu>-->
<!--                                </el-dropdown>-->
                                <el-button size="medium" @click="print" icon="el-icon-printer" ></el-button>
                              </div>
                            </card>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="5" class="mb-lg-10">
                            <el-col :sm="24" :md="12" :lg="24" class="mb-3">
                                <div style="text-align: center;">
                                    <div class="card card-lift shadow border-0 card-img_card_calendar">
                                        <h5 class="card_new_title">{{$t('homepage.calendar')}}</h5>
                                        <div>
                                            <v-calendar is-expanded style="border: 0px; margin-left: -7px;"></v-calendar>
                                        </div>
                                    </div>
                                    <!--                                <router-link to="/pressservice" class="mt-3 button_new_m btnnew_primary">-->
                                    <!--                                    {{$t('homepage.button_news')}}-->
                                    <!--                                </router-link>-->
                                </div>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="24">
                                <div class="card card-lift shadow border-0 card-img_card_news">
                                    <h5 class="card_new_title">{{ $t("homepage.last_news") }}</h5>
                                    <div class="card_news_items">
                                        <div v-for="(item, lnIndex) in lastNews" :key="'lastNews_'+lnIndex">
                                            <div class="time_info">
                                                <span>{{ parseDate(item.createdDate) }}</span>
                                                <hr/>
                                                <span v-if="$i18n.locale === 'uz-UZ'">{{item.category.nameUzLat}}</span>
                                                <span v-if="$i18n.locale === 'uz-CYR'">{{item.category.nameUz}}</span>
                                                <span v-if="$i18n.locale === 'ru-RU'">{{item.category.nameRu}}</span>
                                                <span v-if="$i18n.locale === 'en-US'">{{item.category.nameEn}}</span>
                                            </div>
                                            <span  @click="openNew(item.id)" style="cursor: pointer;">
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'uz-UZ'">{{item.titleUzLat}}</span>
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'uz-CYR'">{{item.titleUz}}</span>
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'ru-RU'">{{item.tilteRu }}</span>
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'en-US'">{{item.titleEn}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import { Facebook, Twitter, Telegram } from 'vue-socialmedia-share';

    export default {
        components: {
            Facebook,
            Twitter,
            Telegram
        },
        data() {
            return {
                news: {},
                newsContent: "",
                lastNews: [],
                currentNews: null,
                pageUrl: "",
                pageTitle: ""
            }
        },
        methods: {
            parseDate(dateTime) {
                return moment(dateTime).format("DD.MM.YYYY");
            },
            loadTheNews(newsId) {
                this.$axios.get(`https://www.prokuratura.uz/api/news/detail/${newsId}`).then(response => {
                    switch (this.$i18n.locale) {
                        case "uz-UZ":
                            this.newsContent = response.data.textUzLat.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            this.pageTitle = response.data.titleUz;
                            break;
                        case "uz-CYR":
                            this.newsContent = response.data.textUz.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            this.pageTitle = response.data.titleUzLat;
                            break;
                        case "ru-RU":
                            this.newsContent = response.data.textRu.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            this.pageTitle = response.data.tilteRu;
                            break;
                        case "en-US":
                            this.newsContent = response.data.textEn.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            this.pageTitle = response.data.titleEn;
                            break;
                    }
                    this.pageUrl = "https://www.prokuratura.uz/#" + this.$route.fullPath;
                    this.news = response.data;
                });
            },
            openNew(newsId){
                this.loadTheNews(newsId);
            },
          print () {
            this.$htmlToPaper('printMe');
          }
        },
        watch: {
            $route(to, from) {
                let newsId = this.$route.query.id;
                this.loadTheNews(newsId);
            }
        },
        created() {
            let newsId = this.$route.query.id;
            this.loadTheNews(newsId);
            this.$axios
                .get(`https://www.prokuratura.uz/api/news/last-news?size=8`)
                .then(response => {
                    this.lastNews = response.data.content;
                    this.currentNews = this.lastNews[0];
                });
        }
    }
</script>
<style scoped>
    @import url(../assets/css/custom.scss);
    /*.new_responsive p img {*/
    /*    width: 100% !important;*/
    /*    display: block;*/
    /*}*/

    /*.new_responsive div img {*/
    /*    width: 100% !important;*/
    /*    display: block;*/
    /*}*/

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    hr {
        border: none;
        border-left: 1px solid #00b0f0;
        height: 14px;
        margin: 4px 5px;
        width: 1px;
    }

    .button_new_m {
        display: block;
        white-space: inherit;
        line-height: 1;
        font-weight: 500;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }

    .btnnew_primary {
        text-align: center;
        white-space: normal;
        vertical-align: middle;
        user-select: none;
        font-size: 15px;
        padding: 0.625rem 1.25rem;
        border-radius: 0px;
        color: #fff;
        background-color: #96b4d3;
        border-color: #96b4d3;
        margin-bottom: .5rem;
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    }
    .print_div {
      padding-right: 20px;
      padding-bottom: 20px;
      display: block;
      text-align: right;
    }
</style>
